import { Col, Form, Modal, Row, message } from "antd";
import React from "react";
import InputComponent from "../../../components/FormComponent/Input";
import "./index.scss";
import ButtonBase from "../../../components/Button";
import {
  useCreateCompanyHierarchyMutation,
  useUpdateCompanyHierarchyMutation,
} from "../../../store/Settings/CompanyHierarchy";
import { useTranslation } from "react-i18next";
import { useValidationRules } from "../../../constants/rules";

const CreateEditCompanyHierarchy = (props) => {
  const { t } = useTranslation();
  const { modalCreate, setModalCreate, handleSubmit, hasEditPermission } =
    props;
  const { InputTextRule } = useValidationRules();

  const [createCompanyHierarchy, { isLoading }] =
    useCreateCompanyHierarchyMutation();
  const [updateCompanyHierarchy, { isLoadingUpdate }] =
    useUpdateCompanyHierarchyMutation();

  const onSubmitCompanyHierarchy = async (values) => {
    try {
      if (modalCreate.data) {
        await updateCompanyHierarchy({
          id: modalCreate.data.id,
          data: values,
        }).unwrap();
        message.success(t("setting.updateSuccess"));
      } else {
        await createCompanyHierarchy(values).unwrap();
        message.success(t("setting.createSuccess"));
      }
      setModalCreate({ data: {}, isOpen: false });
    } catch (error) {
      if (error?.data?.name) {
        message.error(error?.data?.name?.[0]);
      } else {
        message.error(error?.data?.message);
      }
    }
  };

  return (
    <Modal
      title={!modalCreate.data ? t("setting.create") : t("setting.edit")}
      open={modalCreate.isOpen}
      footer={false}
      onCancel={() => setModalCreate({ data: {}, isOpen: false })}
      onOk={handleSubmit}
    >
      <Form
        className="form-create-department"
        onFinish={onSubmitCompanyHierarchy}
        initialValues={modalCreate.data}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Form.Item
              name="name"
              rules={[
                { required: true, message: t("setting.pleaseEnterField") },
                InputTextRule,
              ]}
            >
              <InputComponent title={t("setting.title")} required />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description" rules={[InputTextRule]}>
              <InputComponent title={t("setting.detail")} />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex justify-center mt-4">
          <ButtonBase
            disabled={!hasEditPermission && modalCreate?.data?.id}
            loading={isLoading || isLoadingUpdate}
            title={t("common.submit")}
            htmlType="submit"
          />
        </div>
      </Form>
    </Modal>
  );
};

export default CreateEditCompanyHierarchy;
